import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyD4e9OiKYdONTAM_zb7MEb6CXJExPfINtM",
  authDomain: "simularcp.firebaseapp.com",
  projectId: "simularcp",
  storageBucket: "simularcp.firebasestorage.app",
  messagingSenderId: "1030255718154",
  appId: "1:1030255718154:web:6e1f339cb77933341f54f3",
  measurementId: "G-7GD3R73BYP"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar Analytics solo si es compatible
let analytics = null;
isSupported().then(yes => yes ? analytics = getAnalytics(app) : null);

export { analytics };
export default app; 